import { motion } from 'framer-motion'
import { useT } from '../i18n/t'
import { fadeUp } from '../lib/motion'

const patronageLogo = '/patronat-marszalka.png'

type LandingPatronageSectionProps = {
  /** Wąski blok w kolumnie formularza (bez pełnej sekcji landingowej). */
  embedded?: boolean
  /** Bez animacji wejścia przy scrollu. */
  calm?: boolean
}

export function LandingPatronageSection({
  embedded = false,
  calm = false,
}: LandingPatronageSectionProps) {
  const { t } = useT()
  const headingId = embedded ? 'formularz-patronage-heading' : 'landing-patronage-heading'

  const body = (
    <>
      <h2
        id={headingId}
        className={
          embedded
            ? 'text-[11px] font-extrabold uppercase tracking-[0.18em] text-ink/55'
            : 'text-center text-[11px] font-extrabold uppercase tracking-[0.18em] text-ink/55'
        }
      >
        {t('landing.patronage.title')}
      </h2>
      <div
        className={
          embedded
            ? 'mt-6 flex justify-start'
            : 'mt-8 flex justify-center md:mt-10'
        }
      >
        <img
          src={patronageLogo}
          alt={t('landing.patronage.logoAlt')}
          draggable={false}
          loading="lazy"
          decoding="async"
          className={
            embedded
              ? 'h-auto w-full max-w-[220px] select-none object-contain sm:max-w-[260px]'
              : 'h-auto w-full max-w-[260px] select-none object-contain md:max-w-[320px] lg:max-w-[360px]'
          }
        />
      </div>
    </>
  )

  if (embedded) {
    return (
      <div aria-labelledby={headingId} className="mt-8 border-t border-ink/10 pt-8">
        {body}
      </div>
    )
  }

  if (calm) {
    return (
      <section aria-labelledby={headingId} className="border-t border-ink/10 bg-paper">
        <div className="container-x py-12 md:py-16">
          <div className="content">{body}</div>
        </div>
      </section>
    )
  }

  return (
    <section aria-labelledby={headingId} className="border-t border-ink/10 bg-paper">
      <motion.div
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.2 }}
        variants={{ visible: { transition: { staggerChildren: 0.08 } } }}
        className="container-x pb-14 md:pb-20"
      >
        <div className="content">
          <motion.div variants={fadeUp}>{body}</motion.div>
        </div>
      </motion.div>
    </section>
  )
}
